import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

import { hideErrorMessage } from '../actions'
import Modal from './ui/modal'
import { Button } from './ui/button'
import { Success } from '../assets/icons'
import Error from '../assets/icons/error'

const ApiErrorMessage = props =>
  props.errorMessage.message ? (
    <Modal>
      <Container>
         <Error />
        <Text1> {props.errorMessage.message}</Text1>
        <Button label="Cerrar" $variant="primary" onClick={props.hideErrorMessage} />
      </Container>
    </Modal>
  ) : null

const mapDispatchToProps = { hideErrorMessage }
function mapStateToProps({ errorMessage }) {
  return { errorMessage }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApiErrorMessage)

const Container = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  font-size: 24px;
  background: ${props => props.theme.colors.brand.white};
  color: ${props => props.theme.colors.feedback.error};
  width: 100%;
  border-radius: 25px;
  gap: 12px;
  @media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
    ¡display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
  }

  > i {
    font-size: 60px;
    margin-bottom: 20px;
  }
`
export const Text1 = styled.p`
  font-size: ${props => props.size || '20px'};
  line-height: ${props => props.lineHeight || '24px'};
  color: ${props => props.color || props.theme.colors.brand.blueOmint};
  font-weight: ${props => props.fontWeight || 600};
  margin: 0;
`
